import React from 'react'
import { Spinner, SpinnerProps } from '@chakra-ui/react'

const Component: React.FC<SpinnerProps> = props => (
  <Spinner {...props} speed="0.45s" color="primary.500" emptyColor="gray.400" />
)

export default Component
